import { Divider, Text2, Text3, TextLink, skinVars } from '@telefonica/mistica';
import React, { useEffect } from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';
import navigateParams from '../../../../utils/navigation/navigateParams';
import { useLocation, useSearchParams } from 'react-router-dom';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';

const ModalExtraBonus: React.FC = () => {
    const { t } = useTranslation();
    const { state } = useLocation();
    const [searchParams] = useSearchParams();
    const type: any = searchParams.get('type');
    const storage = localStorage.getItem('storage') || '';
    const { trackingScreenView } = new TrackingEvents();
    let storageData: any;
    if (storage) {
        storageData = JSON.parse(storage);
    }

    const sendToNative = (url: string, type: any, title: any) => {
        const queryParams = {};
        if (navigateParams(type, url, queryParams, {}, title)) {
            window.location.href = url;
        }
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <div className='modalExtraBonus-page'>
            <div className='modalExtraBonus-page__content'>
                <div className='modalExtraBonus-page__content-title'>
                    <Text3 regular>{t('modalExtraBonusTitle')}</Text3>
                </div>
                <div className='modalExtraBonus-page__content-text'>
                    <Text2 regular color={skinVars.colors.textSecondary}>
                        {type}
                    </Text2>
                </div>
            </div>
            <div className='modalExtraBonus-page__divider'>
                <Divider></Divider>
            </div>
            <TextLink
                underline='on hover'
                className='modalExtraBonus-page__link'
                onPress={() => sendToNative('https://o2online.es/ayuda/bonoextradatos/', 'modeBrowser', '')}
            >
                {t('modalExtraBonusLink')}
            </TextLink>
        </div>
    );
};

export default ModalExtraBonus;
